import { Text, IcMarketing } from '@fozito/common-ui';
import fozito_logo from 'assets/logo.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import Alarm from '../Alarm';

import IcCahier from './icons/cashier.svg';
import IcCreditCard from './icons/credit-card.svg';
import IcCustomer from './icons/customer.svg';
import IcGiftCard from './icons/gift-card.svg';
import IcLogout from './icons/logout.svg';
import IcProduct from './icons/product.svg';
import IcQrScan from './icons/QR-scan.svg';
import IcRefresh from './icons/refresh.svg';
import IcReport from './icons/report.svg';
import IcSetting from './icons/setting.svg';
import IcStaff from './icons/staff.svg';
import IcTicket from './icons/ticket.svg';
import IcHome from './icons/home.svg';


import IcCashierActive from './icons/cashier-active.svg';
import IcCreditCardActive from './icons/credit-card-active.svg';
import IcCustomActive from './icons/customer-active.svg';
import IcGiftCardActive from './icons/gift-card-active.svg';
import IcProductActive from './icons/product-active.svg';
import IcReportActive from './icons/report-active.svg';
import IcSettingActive from './icons/setting-active.svg';
import IcStaffActive from './icons/staff-active.svg';
import IcTicketActive from './icons/ticket-active.svg';
import IcHomeActive from './icons/home-active.svg';

import authService from 'modules/auth/services';
import { cashierCtrl } from 'modules/POS/Cashier/cashier.controller';
import useModalGetTicketNumber from 'modules/POS/Cashier/features/ModalGetTicketNumber';
import { ReactNode } from 'react';

export enum MenuOptions {
  HOME = 'HOME',
  CASHIER = 'CASHIER',
  SCAN_QR = 'SCAN_QR',
  TICKETS = 'TICKETS',
  CREDIT_CARDS = 'CREDIT_CARDS',
  CUSTOMERS = 'CUSTOMERS',
  REPORT = 'REPORT',
  PRODUCT = 'PRODUCT',
  REFRESH = 'REFRESH',
  SETTING = 'SETTING',
  LOGOUT = 'LOGOUT',
  STAFF = 'STAFF',
  GIFT_CARD = 'GIFT_CARD',
  PROMOTIONS = 'PROMOTIONS',
}
export type MenuItemConfig = {
  icon: string | ReactNode;
  iconActive: string | ReactNode;
  label: string;
  path?: string;
  button?: boolean;
  disabled?: boolean;
  private?: boolean;
};
export const configs: Record<any, MenuItemConfig> = {
  [MenuOptions.HOME]: {
    icon: IcHome,
    iconActive: IcHomeActive,
    label: 'Home',
    path: '/home',
  },
  [MenuOptions.CASHIER]: {
    icon: IcCahier,
    iconActive: IcCashierActive,
    label: 'Cashier',
    path: '/',
    button: true,
  },
  [MenuOptions.SCAN_QR]: {
    icon: IcQrScan,
    iconActive: IcQrScan,
    label: 'Scan',
    path: '/scan-qr',
    button: true,
  },
  [MenuOptions.TICKETS]: {
    icon: IcTicket,
    iconActive: IcTicketActive,
    label: 'Tickets',
    path: '/ticket',
    private: true,
  },
  [MenuOptions.CREDIT_CARDS]: {
    icon: IcCreditCard,
    iconActive: IcCreditCardActive,
    label: 'Credit Cards',
    path: '/credit-card',
    private: true,
  },
  [MenuOptions.REPORT]: {
    icon: IcReport,
    iconActive: IcReportActive,
    label: 'Report',
    path: '/report',
    private: true,
  },
  [MenuOptions.PRODUCT]: {
    icon: IcProduct,
    iconActive: IcProductActive,
    label: 'Inventory',
    path: '/product',
  },
  [MenuOptions.CUSTOMERS]: {
    icon: IcCustomer,
    iconActive: IcCustomActive,
    label: 'Customers',
    path: '/setting/customer',
  },
  [MenuOptions.REFRESH]: {
    icon: IcRefresh,
    iconActive: 'refresh_icon_active',
    label: 'Refresh',
    path: '/refresh',
    button: true,
  },
  [MenuOptions.SETTING]: {
    icon: IcSetting,
    iconActive: IcSettingActive,
    label: 'Control Panel',
    path: '/setting/general_configuration',
    private: true,
  },
  [MenuOptions.LOGOUT]: {
    icon: IcLogout,
    iconActive: IcLogout,
    label: 'Log Out',
    path: '/logout',
    button: true,
  },
  [MenuOptions.STAFF]: {
    icon: IcStaff,
    iconActive: IcStaffActive,
    label: 'Staffs',
    path: '/setting/staff',
    private: true,
  },
  [MenuOptions.GIFT_CARD]: {
    icon: IcGiftCard,
    iconActive: IcGiftCardActive,
    label: 'Gift Cards',
    path: '/setting/gift-card',
    private: true,
  },
  [MenuOptions.PROMOTIONS]: {
    icon: <IcMarketing width={56} height={56} fill='#2D6772' />,
    iconActive: <IcMarketing width={56} height={56} fill='#FFF' />,
    label: 'Promotions',
    path: '/promotions',
  },
};

const HomeMenuStyled = styled.button`
  display: flex;
  align-self: stretch;
  padding: 12px 0px;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #e5e6eb;
  background: #fcfcfd;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4),
    0px 4px 8px -3px rgba(45, 35, 66, 0.3), 0px -3px 0px 0px #d6d6e7 inset;

  &.activeIcon {
    background: var(--Orange-03, #dc5500);
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4),
      0px 4px 8px -3px rgba(45, 35, 66, 0.3),
      0px -6px 0px 0px rgba(187, 74, 2, 0.5) inset;
    border-bottom: 0;
    border-radius: 4px;
  }

  .active-text {
    padding-left: 4px;
    padding-right: 4px;
    color: #fff;
  }
  .icon {
    width: 56px;
    height: 56px;
  }

  .style-text {
    padding-left: 4px;
    padding-right: 4px;
  }

  &:hover,
  &:active {
    opacity: 0.8;
    transform: scale(1.05);
    transition: all 0.1s;
  }
`;

const ImageIcon = styled.div`
  position: relative;
  .gif-card {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(30px, -10px);
  }
`;

type UIHomeMenuProps = {
  type: keyof typeof MenuOptions;
  onClick?: () => void;
  active?: boolean;
  disabled?: boolean;
};
export const HomeMenu = ({
  type,
  onClick = () => undefined,
  active,
  disabled,
}: UIHomeMenuProps) => {
  const config = configs?.[type];
  if (!config) return null;
  return (
    <HomeMenuStyled
      disabled={disabled}
      type='button'
      onClick={onClick}
      className={active ? 'activeIcon' : ''}
    >
      <ImageIcon>
        {active ? (
          typeof config.iconActive == 'string' ? (
            <img src={config.iconActive} alt={config.label} className='icon' />
          ) : (
            config.iconActive
          )
        ) : typeof config.icon == 'string' ? (
          <img src={config.icon} alt={config.label} className='icon' />
        ) : (
          config.icon
        )}
      </ImageIcon>

      <Text
        content_content_2_16_medium
        text_center
        color_text_4
        className={active ? 'active-text' : 'style-text'}
      >
        {config.label}
      </Text>
    </HomeMenuStyled>
  );
};

const HomeV2Header = () => {
  const { shop_id = '' } = useParams<{ shop_id: string }>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const activePath = path.replace(`/store/${shop_id}`, '');
  const [getTicketNumber, getTicketNumberContext] = useModalGetTicketNumber();

  const activeHome = (path: string) => {
    if (path === '/') return activePath === '' || activePath === '/';
    if (path.includes('/setting') && activePath.includes('/setting')) return true;
    return activePath.includes(path);
  };

  const onNav = (path: string) =>
    navigate(path == '/' ? `/store/${shop_id}` : `/store/${shop_id}${path}`);
  const onNavClick = (type: MenuOptions, config: MenuItemConfig) => () => {

    const callback = () => {
      if (config.button) {
        switch (type) {
          case MenuOptions.CASHIER:
            getTicketNumber.current?.open();
            break;
          case MenuOptions.REFRESH:
            navigate(0);
            break;
          case MenuOptions.LOGOUT:
            dispatch(authService.slice.actions.expiredToken());
            storage.token.set('');
            storage.refreshToken.set('');
            navigate('/login');
            break;
          default:
            break;
        }
        return;
      }

      onNav(config.path || '');
    };

    if (activePath.includes('/cashier')) {
      return cashierCtrl.autoSaveTicket(callback);
    }
    callback();
  };

  return (
    <Container>
      <div className='icon-left'>
        <img src={fozito_logo} alt='fozito_logo' />
        <LeftBox>
          <div className='station-box'>
            <span>Station {storage.station_number.get()}</span>
          </div>
          <Alarm />
        </LeftBox>
      </div>
      <RightBox>
        {Object.entries(configs).map(([key, value]) => (
          <HomeMenu
            active={activeHome(value.path || '')}
            key={key}
            disabled={value.disabled}
            type={key as keyof typeof MenuOptions}
            onClick={onNavClick(key as MenuOptions, value)}
          />
        ))}
      </RightBox>
      {getTicketNumberContext}
    </Container>
  );
};

export default HomeV2Header;

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  background: #fff;
  padding: 12px 24px;
  .icon-left {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }
`;
const LeftBox = styled.div`
  height: 100%;
  display: flex;
  background: #232f3e;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  gap: 24px;
  min-width: 800px;
  .station-box {
    display: flex;
    height: 48px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #fff;
    span {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
    }
  }

  .today-label {
    display: flex;
    .digital {
      display: inline-flex;
      align-items: center;
    }
    .digital p {
      color: #fbe696;
      font-size: 55px;
    }
  }
  .clock .hour {
    line-height: unset;
  }
  .clock .hour .ampm,
  .clock .hour .digital :last-child {
    color: #fbe696;
    font-weight: 600;
  }
`;
const RightBox = styled.div`
  display: flex;
  padding: 0;
  align-items: center;
  flex-shrink: 0;
  flex: 1;
  background: #fff;
  button.btn {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    flex: 1 0 0;
    align-self: stretch;
    background: #fcfcfd;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4),
      0px 4px 8px -3px rgba(45, 35, 66, 0.3), 0px -3px 0px 0px #d6d6e7 inset;
    img.icon-action {
      display: flex;
      width: 80px;
      height: 80px;
      justify-content: center;
      align-items: center;
    }
    span {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    &:hover {
      background: #eee;
    }

    &.active {
      background: #ffe5e7;
    }
  }
`;
